import {
  DWB_PROGRAM_TYPE,
  HIGH_SCHOOL_PROGRAM_TYPE,
  K5_PROGRAM_TYPE,
  MSP_PROGRAM_TYPE,
} from 'utils/program/types'
import {
  HS_TRAINING_COURSE_CODE,
  K5_TRAINING_COURSE_CODE,
  MS_TRAINING_COURSE_CODE,
} from './constants'
import { getProductNameFromUrl } from 'utils/routing/routeHelpers'

export const TRAINING_PROGRAM_CONFIG = {
  elementary: {
    instructorDataKey: 'K5SelDigital',
    contentGroupCode: K5_PROGRAM_TYPE,
    trainingCourseCode: K5_TRAINING_COURSE_CODE,
  },
  'middle-school': {
    instructorDataKey: 'MspDigital',
    contentGroupCode: MSP_PROGRAM_TYPE,
    trainingCourseCode: MS_TRAINING_COURSE_CODE,
  },
  'high-school': {
    instructorDataKey: 'HighSchool',
    contentGroupCode: HIGH_SCHOOL_PROGRAM_TYPE,
    trainingCourseCode: HS_TRAINING_COURSE_CODE,
  },
  'digital-well-being': {
    instructorDataKey: 'Dwb',
    contentGroupCode: DWB_PROGRAM_TYPE,
    usesBandCourseCodes: true,
  },
}

export const resolveTrainingProgramConfig = pathname => {
  const productName = getProductNameFromUrl(pathname)
  return TRAINING_PROGRAM_CONFIG[productName] || null
}
